import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "card-deck" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "dropdown mb-2" }
const _hoisted_8 = {
  class: "text-primary",
  "data-toggle": "dropdown"
}
const _hoisted_9 = {
  class: "dropdown-menu",
  style: {"max-height":"250px","overflow-y":"auto"}
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "dropdown d-inline-block" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "dropdown-menu" }
const _hoisted_14 = { class: "dropdown d-inline-block" }
const _hoisted_15 = {
  class: "btn btn-outline-secondary btn-sm dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_16 = { class: "dropdown-menu" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "dropdown mb-2"
}
const _hoisted_21 = {
  class: "text-primary dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_22 = { class: "dropdown-menu" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "mb-1 d-flex justify-content-end" }
const _hoisted_25 = { class: "dropdown d-inline-block mr-1" }
const _hoisted_26 = {
  class: "btn btn-sm btn-outline-secondary dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_27 = { class: "dropdown-menu" }
const _hoisted_28 = { class: "dropdown d-inline-block mr-1" }
const _hoisted_29 = { class: "dropdown-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KendoGridColumnsEditorDialog = _resolveComponent("KendoGridColumnsEditorDialog")!
  const _component_ScoringVotesSourceSelectorDialog = _resolveComponent("ScoringVotesSourceSelectorDialog")!
  const _component_SaveToAttributeDialog = _resolveComponent("SaveToAttributeDialog")!
  const _component_BarChartDialog = _resolveComponent("BarChartDialog")!
  const _component_RadarChartDialog = _resolveComponent("RadarChartDialog")!
  const _component_SensitivityAnalysisChartDialog = _resolveComponent("SensitivityAnalysisChartDialog")!
  const _component_CriterionSelectorDialog = _resolveComponent("CriterionSelectorDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _component_GoalNavigation = _resolveComponent("GoalNavigation")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_KendoGridColumnsEditorDialog, {
      propOpened: _ctx.kendoGridColumnsEditorDialogOpened,
      propGrid: _ctx.Grid,
      onCloseDialog: _cache[0] || (_cache[0] = ($event: any) => (_ctx.kendoGridColumnsEditorDialogOpened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propGrid"]),
    _createVNode(_component_ScoringVotesSourceSelectorDialog, {
      propOpened: _ctx.scoringVotesSourceSelectorDialog.opened,
      propDefaultSurveyId: _ctx.scoringVotesSourceSelectorDialog.defaultSurveyId,
      propDefaultProjectUserId: _ctx.scoringVotesSourceSelectorDialog.defaultProjectUserId,
      propSurveys: _ctx.surveys,
      propProjectUsers: _ctx.projectUsers,
      onConfirmSelection: _ctx.changeScoringVotesSource,
      onLoadPanelists: _ctx.loadScoringPanelists,
      onCloseDialog: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scoringVotesSourceSelectorDialog.opened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propDefaultSurveyId", "propDefaultProjectUserId", "propSurveys", "propProjectUsers", "onConfirmSelection", "onLoadPanelists"]),
    _createVNode(_component_SaveToAttributeDialog, {
      viewModel: _ctx.saveToAttributeDialog,
      onSaveNewAttribute: _ctx.handleSaveResultsToNewAttributeCommand,
      onSaveExistingAttribute: _ctx.handleSaveResultsToExistingAttributeCommand
    }, null, 8 /* PROPS */, ["viewModel", "onSaveNewAttribute", "onSaveExistingAttribute"]),
    _createVNode(_component_BarChartDialog, { viewModel: _ctx.barChartDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_RadarChartDialog, { viewModel: _ctx.radarChartDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_SensitivityAnalysisChartDialog, { viewModel: _ctx.sensitivityAnalysisChartDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_CriterionSelectorDialog, {
      viewModel: _ctx.criterionSelectorDialog,
      onConfirmSelection: _ctx.changeCriterion
    }, null, 8 /* PROPS */, ["viewModel", "onConfirmSelection"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.rm)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [...(_cache[20] || (_cache[20] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Loading... ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.rm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h3", null, "Goal: " + _toDisplayString(_ctx.goalName), 1 /* TEXT */),
            _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createVNode(_component_GoalNavigation, {
              WorkspaceId: _ctx.workspaceId,
              ProjectId: _ctx.projectId,
              EvalModelId: _ctx.evalModelId,
              ActivePage: "results",
              ScoringEnabled: _ctx.rm.ScoringEnabled
            }, null, 8 /* PROPS */, ["WorkspaceId", "ProjectId", "EvalModelId", "ScoringEnabled"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[26] || (_cache[26] = _createElementVNode("h5", { class: "card-title" }, "Ranking", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[23] || (_cache[23] = _createTextVNode(" List: ", -1 /* CACHED */)),
                    _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.selectedList?.Name ?? 'All'), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeViewDef(null)))
                      }, "All"),
                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      _cache[22] || (_cache[22] = _createElementVNode("h6", { class: "dropdown-header" }, "Custom lists", -1 /* CACHED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lists, (l) => {
                        return (_openBlock(), _createElementBlock("a", {
                          class: "dropdown-item",
                          onClick: ($event: any) => (_ctx.changeViewDef(l.Id))
                        }, _toDisplayString(l.Name), 9 /* TEXT, PROPS */, _hoisted_10))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ]),
                  _createElementVNode("p", null, [
                    _cache[24] || (_cache[24] = _createTextVNode("Rank by: ", -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showCriterionSelectorDialog && _ctx.showCriterionSelectorDialog(...args)))
                    }, _toDisplayString(_ctx.selectedCriterion?.Name), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary btn-sm dropdown-toggle mr-1",
                      type: "button",
                      "data-toggle": "dropdown",
                      disabled: _ctx.dataReady === false
                    }, " Save to attribute ", 8 /* PROPS */, _hoisted_12),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showScoreToAttributeSaverDialog && _ctx.showScoreToAttributeSaverDialog(...args)))
                      }, "Value score"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showRankToAttributeSaverDialog && _ctx.showRankToAttributeSaverDialog(...args)))
                      }, "Rank position")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", _hoisted_15, _toDisplayString(_ctx.precisionLabel), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[25] || (_cache[25] = _createElementVNode("h6", { class: "dropdown-header" }, "Precision:", -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changePrecision(0)))
                      }, "1.0"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changePrecision(1)))
                      }, "0.1"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changePrecision(2)))
                      }, "0.01"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changePrecision(3)))
                      }, "0.001"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePrecision(4)))
                      }, "0.0001"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changePrecision(5)))
                      }, "0.00001")
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[30] || (_cache[30] = _createElementVNode("h5", { class: "card-title" }, "Data", -1 /* CACHED */)),
                  (_ctx.weightsSets.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, [...(_cache[27] || (_cache[27] = [
                        _createTextVNode("Weights: ", -1 /* CACHED */),
                        _createElementVNode("span", { class: "text-danger" }, "You don't have any weights sets. You can create them on the weights page.", -1 /* CACHED */)
                      ]))]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.weightsSets.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _cache[28] || (_cache[28] = _createTextVNode(" Weights: ", -1 /* CACHED */)),
                        _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.selectedWeightsSet?.Name ?? 'None'), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_22, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weightsSets, (ws) => {
                            return (_openBlock(), _createElementBlock("a", {
                              class: "dropdown-item",
                              key: ws.Id,
                              onClick: ($event: any) => (_ctx.changeWeightsSet(ws.Id))
                            }, _toDisplayString(ws.Name), 9 /* TEXT, PROPS */, _hoisted_23))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("p", null, [
                    _cache[29] || (_cache[29] = _createTextVNode("Scores: ", -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.showScoringVotesSourceSelectorDialog && _ctx.showScoringVotesSourceSelectorDialog(...args)))
                    }, _toDisplayString(_ctx.selectedScoresSourceLabel), 1 /* TEXT */)
                  ])
                ])
              ])
            ]),
            _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _withDirectives(_createElementVNode("h2", null, [...(_cache[31] || (_cache[31] = [
              _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
              _createTextVNode(" Loading data...", -1 /* CACHED */)
            ]))], 512 /* NEED_PATCH */), [
              [_vShow, _ctx.dataReady === false]
            ]),
            _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", _hoisted_26, " Compare (" + _toDisplayString(_ctx.selectedAlternatives.length) + ") ", 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.showBarChartDialog && _ctx.showBarChartDialog(...args)))
                    }, "Bar chart"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.showRadarChartDialog && _ctx.showRadarChartDialog(...args)))
                    }, "Radar chart"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.showSensitivityAnalysisChartDialog && _ctx.showSensitivityAnalysisChartDialog(...args)))
                    }, "Sensitivity analysis")
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _cache[33] || (_cache[33] = _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-secondary dropdown-toggle",
                    "data-toggle": "dropdown"
                  }, " Edit columns ", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.showGridColumnsEditor && _ctx.showGridColumnsEditor(...args)))
                    }, "Custom"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.showSubcriteriaColumns && _ctx.showSubcriteriaColumns(...args)))
                    }, "Subcriteria"),
                    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.resetGridColumns && _ctx.resetGridColumns(...args)))
                    }, "Reset")
                  ])
                ]),
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary btn-sm",
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.ExportGridCommand && _ctx.ExportGridCommand(...args))),
                  title: "Download to spreadsheet"
                }, [...(_cache[34] || (_cache[34] = [
                  _createElementVNode("i", { class: "fa fa-download fa-lg" }, null, -1 /* CACHED */)
                ]))])
              ]),
              _cache[35] || (_cache[35] = _createElementVNode("div", { id: "mygrid" }, null, -1 /* CACHED */))
            ], 512 /* NEED_PATCH */), [
              [_vShow, _ctx.dataReady === true]
            ]),
            _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1 /* CACHED */))
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}